import { render, staticRenderFns } from "./importacoes-icon.vue?vue&type=template&id=38b9261b&"
import script from "./importacoes-icon.vue?vue&type=script&lang=js&"
export * from "./importacoes-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports